import { Delete, Edit } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useState } from 'react'

import AuditIconButton from '../../../../base/components/Auditoria/AuditIconButton'
import { notDanger, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiEliminarGrupoUnidadMedida } from '../../api/apiGrUniMedEliminar'
import { GrupoUnidadMedidaListadoProps, GrupoUnidadMedidaProp } from '../../interfaces'
import GrupoUnidadMedidaActualizar from '../actualizar/GrUniMedActualizarDialog'

interface OwnProps {
  id: string
  row: GrupoUnidadMedidaListadoProps
  refetch: () => any
}

type Props = OwnProps
const GrUniMedListadoMenu: FunctionComponent<Props> = (props) => {
  const { row, refetch } = props
  const confirm = useConfirm()

  const [openGrupoActualizar, setOpenGrupoActualizar] = useState(false)
  const handleDeleteSingleRow = async (row: GrupoUnidadMedidaListadoProps) => {
    const { confirmed } = await confirm({
      title: 'Eliminar Grupo Unidad Medida ',
      content: '¿Está seguro de eliminar el Grupo Unidad Medida?',
    })
    if (confirmed) {
      swalLoading()
      try {
        const resp = await apiEliminarGrupoUnidadMedida(row._id).catch((err) => {
          swalException(err)
          return false
        })
        if (resp) {
          notSuccess('Grupo Unidad Medida eliminado correctamente')
          swalClose()
          refetch()
        }
      } catch (error) {
        swalException(error)
        notDanger('Error al eliminar la contingencia')
      }
    }
  }

  return (
    <>
      <IconButton
        color={'primary'}
        onClick={() => {
          setOpenGrupoActualizar(true)
        }}
      >
        <Edit />
      </IconButton>
      <IconButton
        onClick={() => {
          handleDeleteSingleRow(row)
        }}
        aria-label="delete"
        color="error"
      >
        <Delete />
      </IconButton>

      <AuditIconButton row={row} />
      <GrupoUnidadMedidaActualizar
        id={row._id}
        keepMounted
        open={openGrupoActualizar}
        grupo={row}
        onClose={(value?: GrupoUnidadMedidaProp) => {
          setOpenGrupoActualizar(false)
          if (value) refetch().then()
        }}
      />
    </>
  )
}

export default GrUniMedListadoMenu
